import { createFileRoute } from "@tanstack/react-router";
import { ConsumerContractDeclarationForm } from "~/components/ConsumerContractDeclarationForm";

export const Route = createFileRoute("/kuendigung")({
  head: () => ({
    meta: [
      { title: "Verträge hier kündigen | Alchema" },
      { name: "description", content: "Submit and save an ordinary or extraordinary termination declaration for an Alchema subscription." },
    ],
  }),
  component: TerminationRoute,
});

function TerminationRoute() {
  return <ConsumerContractDeclarationForm mode="termination" />;
}
